<template>
	<div class="wrap-layer">
		<light-header :back="'/user-space/contracts?status=all'"></light-header>
		<div class="steps">
			<div class="step active">
				<span class="circle">1</span>
				选择套餐
			</div>
			<i class="el-icon-arrow-right"></i>
			<div class="step">
				<span class="circle">2</span>
				在线支付
			</div>
			<i class="el-icon-arrow-right"></i>
			<div class="step">
				<span class="circle">3</span>
				完成
			</div>
		</div>
		<div class="cart-body auto">
			<div class="head">
				购买套餐
			</div>
			<ul class="cart-list">
				<li class="cart-item" :class="{check: item.check}" v-for="(item, idx) in cartList" :key="idx" @click="handleCheck(idx)">
					<div class="left">
						<div class="name">{{item.name}}</div>
						<div class="bottom">
							<div class="count">
								{{item.packageCount}}份文件
							</div>
							<div class="">
								有效期{{item.periodDay}}天
							</div>
						</div>
					</div>
					<div class="right">
						<div>
							<span class="big">￥{{item.packagePrice}}</span>
						</div>
						<div class="per">
							{{item.price}}元每份
						</div>
					</div>
					<div class="mask" v-show="item.check">
						立即购买
					</div>
				</li>
				<li class="cart-item more">
					<img src="../../assets/images/cart/cart-more.png" alt="">
					<span>更多选择请敬请期待......</span>
				</li>
			</ul>
			<div class="count-control">
				数量<el-input-number size="small" :disabled="!checkCart" :min="0" v-model="cartCount"></el-input-number>
			</div>
			<el-button type="primary" :disabled="!checkCart || cartCount == 0" class="check-btn" @click="toOrder">下一步</el-button>
		</div>
	</div>
</template>
<script>
	import lightHeader from "../../components/lightHeader";
	import { getSalesPackage, createOrder } from "@/api/cart/cart";
	export default {
		components: {
			lightHeader
		},
		data() {
			return {
				cartList: [{}],
				cartCount: 0
			};
		},
		computed: {
			checkCart() {
				return this.cartList.some(item => {
					return item.check;
				});
			}
		},
		created() {
			getSalesPackage().then(res => {
				res.data.packageArray.map((item, idx) => {
					if (idx === 0) {
						item.check = true;
					} else {
						item.check = false;
					}
				});
				this.cartCount = 1;
				this.cartList = res.data.packageArray;
			});
		},
		mounted() {},
		methods: {
			handleCheck(idx) {
				this.cartList.map(item => {
					item.check = false;
				});
				this.cartList[idx].check = true;
				if (!this.cartCount) {
					this.cartCount = 1;
				}
				
			},
			toOrder() {
				const checkedItem = this.cartList.find(item => {
					return item.check;
				});
				const money = checkedItem.packagePrice * this.cartCount;
				createOrder({
					unitPrice: checkedItem.packagePrice,
					quantity: this.cartCount,
					amount: money,
					packageId: checkedItem.packageId
				}).then(res => {
					if (res.code !== 200) {
						this.$message({
							showClose: true,
							message: res.message,
							type: "warning"
						});
					} else {
						this.$message({
							showClose: true,
							message: "选购成功，请及时支付",
							type: "success"
						});
						this.$store.commit("SET_ORDER_INFO", {
							orderId: res.data.orderId,
							packageName: checkedItem.name,
							count: this.cartCount,
							money: money
						});
						this.$router.replace({
							path: "/cart/order",
							query: {
								orderId: res.data.orderId
							}
						});
					}
				});
			}
		}
	};
</script>
<style lang="scss">
	.steps {
		width: 441px;
		margin: 20px auto;
		display: flex;
		justify-content: space-around;
		align-items: center;
		.step {
			font-size: 16px;
			font-weight: 400;
			color: #333333;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.circle {
				display: block;
				width: 34px;
				height: 34px;
				border: 1px solid #dedcdb;
				border-radius: 50%;
				text-align: center;
				line-height: 34px;
				font-weight: 400;
				color: #c3c3c3;
				font-size: 16px;
				margin-right: 12px;
			}
			&.active {
				.circle {
					background: #3296fa;
					color: #fff;
				}
				color: #3699ff;
				border: none;
			}
		}
	}
</style>
<style lang="scss" scoped>
	.wrap-layer {
		background: #f0f0f5;
		height: 100vh;
		.cart-body {
			background: #fff;
			padding: 27px 30px 50px;
			height: calc(100vh - 145px);
			position: relative;
			.head {
				font-size: 16px;
				font-weight: 400;
				color: #333333;
				border-left: 3px solid #3296fa;
				height: 20px;
				line-height: 20px;
				padding-left: 14px;
			}
			.cart-list {
				padding: 30px 12px;
				overflow: hidden;
				.cart-item {
					width: 266px;
					height: 174px;
					background: #ffffff;
					border: 1px solid #e2e2e7;
					border-radius: 10px;
					padding: 42px 26px 57px;
					display: flex;
					justify-content: space-between;
					align-items: center;
					cursor: pointer;
					float: left;
					position: relative;
					.left,
					.right {
						width: 50%;
						display: flex;
						height: 100%;
						flex-direction: column;
						justify-content: space-between;
						align-items: center;
					}
					.name {
						font-size: 16px;
						font-weight: 400;
						color: #333333;
					}
					.bottom {
						font-size: 14px;
						font-weight: 400;
						color: #999999;
						text-align: center;
					}
					.left {
						position: relative;
					}
					.left::after {
						content: "";
						display: block;
						width: 0;
						height: 72px;
						border-right: 1px solid #f2f2f7;
						position: absolute;
						right: 0;
						top: 4px;
					}
					.right {
						font-size: 14px;
						font-weight: 400;
						color: #3296fa;
						.big {
							font-size: 22px;
							font-weight: bold;
						}
					}
					&.more {
						flex-direction: column;
						padding: 33px 0 19px;
						cursor: default;
						img {
							width: 119px;
							height: auto;
							display: block;
							margin: 0 auto;
						}
						span {
							font-size: 14px;
							font-weight: 400;
							color: #999999;
							margin-top: 17px;
						}
					}
					&.check {
						border: 1px solid #3296fa;
						box-shadow: 0px 1px 18px 0px rgba(50, 150, 250, 0.11);
					}
					.mask {
						width: 100%;
						height: 35px;
						background: rgba(50, 150, 250, 0.1);
						border-radius: 0px 0px 10px 10px;
						position: absolute;
						left: 0;
						bottom: 0;
						font-size: 14px;
						font-weight: 400;
						color: #3296fa;
						text-align: center;
						line-height: 35px;
					}
				}
				.cart-item + .cart-item {
					margin-left: 15px;
				}
			}
			.count-control {
				position: absolute;
				right: 30px;
				bottom: 135px;
				font-size: 16px;
				.el-input-number {
					margin-left: 18px;
				}
			}
			.check-btn {
				width: 335px;
				padding: 15px 0;
				border-radius: 10px;
				text-align: center;
				color: #fff;
				font-size: 16px;
				font-weight: 400;
				color: #ffffff;
				position: absolute;
				left: 50%;
				bottom: 50px;
				transform: translateX(-50%);
			}
		}
	}
</style>
